// vg-binding: P7.D-132
//
// apps/vendor/src/features/cmdk/cmdkStore.ts
//
// Phase 7 Wave 6 Task 22 — command-palette state.
//
// The cmdk dialog is mounted globally by VendorAppShell (or the root
// layout). It listens for the `vendor:cmdk:open` CustomEvent dispatched
// by VendorTopBar (Task 06) + the Cmd/Ctrl+K hotkey hook. This Zustand
// store owns the open/close + active-query state so the trigger button
// and the dialog itself stay loosely coupled.

import { create } from 'zustand';

export interface CmdkState {
  open: boolean;
  query: string;
  /** Reserved — Task 22 follow-up wires recent-actions persistence. */
  recents: string[];

  openPalette: () => void;
  closePalette: () => void;
  setQuery: (q: string) => void;
  recordRecent: (id: string) => void;
}

export const useCmdkStore = create<CmdkState>((set, get) => ({
  open: false,
  query: '',
  recents: [],

  openPalette: () => set({ open: true, query: '' }),
  closePalette: () => set({ open: false }),
  setQuery: (q) => set({ query: q }),
  recordRecent: (id) => {
    const prev = get().recents.filter((r) => r !== id);
    set({ recents: [id, ...prev].slice(0, 5) });
  },
}));
